import React from "react"
import { GatsbyImage } from "gatsby-plugin-image";
import Bricks from "./bricks"
import { hexaToDark, hexaToRgba } from "../functions"

//////////////////////////////////////////////////
// PROPS:
// -	id: ""
// -	className: ""
// -  +
// -	background_color: Object { src: childImageSharp, alt: "" }
// -	background_image: Object { color: "FFFFFF", opacity: 0.85 }

class Section extends React.Component {
  render() {
    let { background_color, background_image, ...rest } = this.props
    return (
      <section
        {...rest}
        className={`${
          this.props.background_color && hexaToDark(this.props.background_color)
            ? "dark"
            : ""
        }`}
        children={<Children props={this.props} />}
        style={{ position: "relative" }}
      />
    )
  }
}
export default Section

const Children = ({ props }) => {
  return <>
    {// background image (if set)
    props.background_image && (
      <GatsbyImage
        image={{ ...props.background_image.src.childImageSharp.gatsbyImageData }}
        imgStyle={{ objectFit: "cover" }}
        style={{
          position: "absolute",
          top: 0,
          height: "100%",
          width: "100%",
        }} />
    )}
    {// background color (if set)
    props.background_color && (
      <div
        style={{
          backgroundColor: `${
            props.background_color
              ? hexaToRgba(props.background_color)
              : "initial"
          }`,
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      />
    )}
    <Bricks bricks={props.children} />
  </>;
}
